import http from "./http.js";

async function createPosition(resource, position) {
  const response = await http.post(`isg-logistics/${resource}`, position);
  return response;
}

export {
  createPosition,
};